import React, { useEffect, useState } from 'react';

interface IProps {
  src?: string | null;
  size?: number;
}

const DEFAULT_SIZE = 64;

const PlaceholderGlyph: React.FC<{ size: number }> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M12 3L20.5 7.5V16.5L12 21L3.5 16.5V7.5L12 3Z" stroke="#3800EE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.5 7.5L12 12L20.5 7.5" stroke="#3800EE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 12V21" stroke="#3800EE" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const AssetIcon: React.FC<IProps> = ({ src, size = DEFAULT_SIZE }) => {
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    setErrored(false);
  }, [src]);

  const showImage = Boolean(src) && !errored;

  return (
    <div style={{
      width: `${size}px`,
      height: `${size}px`,
      flexShrink: 0,
      borderRadius: '8px',
      overflow: 'hidden',
      backgroundColor: '#EBE6FF',
      border: '1px solid #D9CFFA',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    >
      {showImage ? (
        <img
          src={src ?? undefined}
          alt="Asset"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          onError={() => setErrored(true)}
        />
      ) : (
        <PlaceholderGlyph size={Math.round(size * 0.55)} />
      )}
    </div>
  );
};
